import { render } from "./App.vue?vue&type=template&id=357bc98a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=357bc98a&lang=css"

import exportComponent from "../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__